module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _c('em', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joe, Butch, Jimmie, Steve, Tony, Lloyd . . . Sharon, Adrienne, Janet . . . and all the more than three dozen men and women who shared their time, insight, and stories with me in the preparation of this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Casey Kittrell and the good folks at U.T. Press, including copyeditor Paul Spragens and book designer Lindsay Starr.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Peter Blackstock and "), _c('em', [_vm._v("No Depression")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Cameron and Peter and New West Records.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("The two Lances—Lance Cowan and Lance Webb.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Two books were most helpful for quotes and in researching this volume: Joe Carr and Alan Munde’s "), _c('em', [_vm._v("Prairie Nights to Neon Lights")]), _vm._v(" (Texas Tech University Press, 1995), a history of West Texas music; and Christopher Oglesby’s "), _c('em', [_vm._v("Fire in the Water, Earth in the Air")]), _vm._v(" (University of Texas Press, 2006), an oral history of West Texas musicians (along with Chris’s website, "), _c('a', {
    attrs: {
      "href": "http://www.virtualubbock.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.virtualubbock.com/")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Another valuable source for background and quotes was Amy Maner and George Sledge’s 2005 documentary film, "), _c('em', [_vm._v("Lubbock Lights")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("David Brown of KUTX-FM in Austin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Michael Ventura and the poets, philosophers, and seekers on 14th Street.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("And a tip of the Stetson to Miles Arceneaux, my favorite Famous Arthur.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac3e5e08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292767317_07_ack.vue
// module id = 78
// module chunks = 0